import { render, staticRenderFns } from "./SendGiftModal.vue?vue&type=template&id=3a89c213&scoped=true&"
import script from "./SendGiftModal.vue?vue&type=script&lang=js&"
export * from "./SendGiftModal.vue?vue&type=script&lang=js&"
import style0 from "./SendGiftModal.vue?vue&type=style&index=0&id=3a89c213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a89c213",
  null
  
)

export default component.exports